module.exports = __webpack_public_path__ + "img/re-en_US-img1.38fe8995.png";